module.exports = __webpack_public_path__ + "img/实体卡.7fda310b.png";